// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected {
  background: rgba(57, 79, 103, 0.3);
}

.disabledbutton {
  pointer-events: none;
  opacity: 0.4;
  cursor: none;
  -webkit-user-select: none;
          user-select: none;
  background: #b6b8b9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.container {
  display: flex;
  flex-direction: column;
  background: rgba(39, 42, 56, 0.99);
  position: absolute;
  min-width: 800px !important;
  min-height: 800px !important;
  top: 10%;
  left: 20%;
  right: 15%;
  bottom: 10%;
  padding: 20px 50px 50px 50px;
  z-index: 1020;
  font-size: 100%;
  color: white;
}
.container .header {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  font-size: 200%;
  margin-bottom: 20px;
  -webkit-user-select: none;
          user-select: none;
}
.container .search {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 3%;
}
.container .search .form__field {
  width: 360px;
  height: 45px;
  background: #cecece;
  color: #000;
  font-size: 16px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
  border: 0;
  outline: 0;
  padding: 22px 18px;
  border-radius: 5px;
}
.container .body {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
  height: 90%;
  font-size: 150%;
}
.container .body .title-row {
  position: relative;
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
}
.container .body .title-row .title-column {
  position: relative;
  width: 50%;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .title-row .title-column:first-child {
  padding-left: 5px;
}
.container .body .title-row .title-column:not(:first-child) {
  padding-left: 20px;
}
.container .body .columns {
  position: relative;
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: row;
}
.container .body .columns .left-side, .container .body .columns .right-side {
  position: relative;
  width: 50%;
  height: 90%;
  display: block;
  overflow-y: auto;
}
.container .body .columns .left-side {
  position: relative;
  padding-right: 10px;
  border-right: 1px solid gray;
}
.container .body .columns .left-side .user {
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 18px;
  background: rgba(57, 79, 103, 0.3);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .columns .left-side .user:not(:first-child) {
  margin-top: 10px;
}
.container .body .columns .left-side .user span {
  padding-left: 20px;
}
.container .body .columns .left-side .no-user {
  width: 100%;
  height: 40px;
  margin-top: 15px;
  align-items: center;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .columns .left-side .no-user span {
  margin-left: 20px;
}
.container .body .columns .right-side {
  position: relative;
  padding-left: 10px;
}
.container .body .columns .right-side .user {
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 5px;
  border-radius: 18px;
  background: rgba(57, 79, 103, 0.3);
  justify-content: space-between;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .columns .right-side .user:not(:first-child) {
  margin-top: 10px;
}
.container .body .columns .right-side .user span {
  padding-left: 20px;
}
.container .body .columns .right-side .user .remove-sign {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: rgba(69, 69, 97, 0.7);
  border-radius: 50%;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .columns .right-side .user .remove-sign:hover {
  background: rgba(46, 46, 65, 0.7);
}
.container .body .columns .right-side .user .remove-sign .sign-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container .body .columns .right-side .no-user {
  width: 100%;
  height: 40px;
  margin-top: 15px;
  align-items: center;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
}
.container .body .columns .right-side .no-user span {
  padding-left: 20px;
}
.container .footer {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  width: 100%;
  height: 10%;
  font-size: 150%;
}
.container .footer .button {
  border-radius: 5px;
}
.container .footer .share {
  background: rgba(28, 73, 119, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.container .footer .copyLink {
  margin-left: 3%;
}
.container .close {
  cursor: pointer;
  padding: 10px 20px 15px 20px;
}
.container .close:hover {
  background: rgba(255, 255, 255, 0.05);
}
.container .header a {
  margin-left: auto;
}
.container .hours-modal {
  padding: 10px 0 0 10px;
  color: white;
  position: absolute;
  top: 75%;
  left: 38%;
  background: #3a3f50;
  width: 35%;
  height: 21%;
  z-index: 2;
  box-shadow: -4px 3px 14px 0px rgba(114, 114, 121, 0.54);
}
.container .hours-modal .btn-copy-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190px;
  height: 45px;
  margin-top: 5px;
  outline: 0 !important;
  background: #fff;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  color: black;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: none !important;
  cursor: pointer;
}
.container .hours-modal-success, .container .hours-modal-error {
  margin: 20px 0 0 25px;
}
.container .hours-modal-success {
  color: white;
}
.container .hours-modal-error {
  color: brown;
}
.container .hours-modal .form-control {
  padding: 0.6rem 0.8rem !important;
  border: 2px solid #ced4da !important;
  transition: none !important;
}
.container .hours-modal select.form-control {
  height: auto !important;
  padding: 0.6rem 0.8rem calc(0.6rem + 1px) 0.8rem !important;
}
.container .hours-modal .select-hours {
  width: 83%;
  display: flex;
  justify-content: space-between;
}
.container .hours-modal .custom-select {
  height: 45px;
  width: 30%;
  padding: 0.6rem 0.8rem !important;
  border: 2px solid #ced4da !important;
  transition: none !important;
  border-radius: 4px;
  margin: 5px 0 10px 0;
}
.container .hours-modal .div-for-link {
  width: 0;
  display: flex;
  justify-content: space-between;
  height: 0;
}
.container .hours-modal .input-for-link {
  display: flex;
  width: 300px;
  height: 45px;
  border: 0;
  box-shadow: none !important;
  outline: none !important;
  background: #ffffff;
  text-align: center;
  border-radius: 5px;
  font-size: 15.5px;
}
.container .hours-modal .copyLinkToClipboard {
  display: flex;
  width: 11%;
  height: 45px;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #565b6b;
  opacity: 0.7;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
}

::-webkit-input-placeholder { /* Chrome */
  color: #000;
}

::-moz-placeholder { /* Firefox 19+ */
  color: #000;
  opacity: 1;
}

:-moz-placeholder { /* Firefox 4 - 18 */
  color: #000;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/select-users-to-share/select-users-to-share.component.scss"],"names":[],"mappings":"AAEA;EACE,kCAAA;AADF;;AAGA;EACE,oBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AAAF;AACE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,2CAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AAAN;AAKE;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAHN;AAKM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAIQ;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;AAFV;AAGU;EACE,iBAAA;AADZ;AAGU;EACE,kBAAA;AADZ;AAKM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAIQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAFV;AAKQ;EACE,kBAAA;EACA,mBAAA;EACA,4BAAA;AAHV;AAIU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAFZ;AAIY;EACE,gBAAA;AAFd;AAKY;EACE,kBAAA;AAHd;AAMU;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;AAJZ;AAMY;EACE,iBAAA;AAJd;AAQQ;EACE,kBAAA;EACA,kBAAA;AANV;AAQU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AANZ;AAQY;EACE,gBAAA;AANd;AASY;EACE,kBAAA;AAPd;AASY;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAPd;AAQc;EACE,iCAAA;AANhB;AASc;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPhB;AAWU;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;AATZ;AAWY;EACE,kBAAA;AATd;AAgBE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;EACA,eAAA;AAfJ;AAgBI;EACE,kBAAA;AAdN;AAiBI;EACE,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAfN;AAiBI;EACE,eAAA;AAfN;AAkBE;EACE,eAAA;EACA,4BAAA;AAhBJ;AAiBI;EACE,qCAAA;AAfN;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAGA,uDAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2BAAA;EACA,eAAA;AAjBN;AAoBI;EACE,qBAAA;AAlBN;AAoBI;EACE,YAAA;AAlBN;AAoBI;EACE,YAAA;AAlBN;AAoBI;EACE,iCAAA;EACA,oCAAA;EACA,2BAAA;AAlBN;AAoBI;EACE,uBAAA;EACA,2DAAA;AAlBN;AAqBI;EACE,UAAA;EACA,aAAA;EACA,8BAAA;AAnBN;AAqBI;EACE,YAAA;EACA,UAAA;EACA,iCAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;AAnBN;AAsBI;EACE,QAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AApBN;AAsBI;EACE,aAAA;EACA,YAAA;EACA,YAAA;EAEA,SAAA;EACA,2BAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AArBN;AAwBI;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAtBN;;AA6BA;EACE,WAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA1BF;;AA4BA;EACE,mBAAA;AAzBF;;AA6BA,8BAAA,WAAA;EACE,WAAA;AA1BF;;AA6BA,qBAAA,gBAAA;EACE,WAAA;EACA,UAAA;AA1BF;;AA4BA,oBAAA,mBAAA;EACE,WAAA;EACA,UAAA;AAzBF","sourcesContent":["$ebony-clay: #272a38;\r\n\r\n.selected {\r\n  background: rgba(57, 79, 103, 0.3);\r\n}\r\n.disabledbutton {\r\n  pointer-events: none;\r\n  opacity: 0.4;\r\n  cursor: none;\r\n  user-select: none;\r\n\r\n  background: #b6b8b9;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px;\r\n}\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: transparentize($ebony-clay, 0.01);\r\n  position: absolute;\r\n  min-width: 800px !important;\r\n  min-height: 800px !important;\r\n  top: 10%;\r\n  left: 20%;\r\n  right: 15%;\r\n  bottom: 10%;\r\n  padding: 20px 50px 50px 50px;\r\n  z-index: 1020;\r\n  font-size: 100%;\r\n  color: white;\r\n  .header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-shrink: 0;\r\n    align-items: center;\r\n    font-size: 200%;\r\n    margin-bottom: 20px;\r\n    user-select: none;\r\n  }\r\n\r\n  .search {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    margin-bottom: 3%;\r\n\r\n    .form__field {\r\n      width: 360px;\r\n      height: 45px;\r\n      background: #cecece;\r\n      color: #000;\r\n      font-size: 16px;\r\n      box-shadow: 0 6px 10px 0 rgba(0, 0, 0 , .1);\r\n      border: 0;\r\n      outline: 0;\r\n      padding: 22px 18px;\r\n      border-radius: 5px;\r\n    }\r\n  }\r\n\r\n\r\n  .body {\r\n      display: flex;\r\n      flex-grow: 1;\r\n      flex-direction: column;\r\n      width: 100%;\r\n      height: 90%;\r\n      font-size: 150%;\r\n\r\n      .title-row {\r\n        position: relative;\r\n        width: 100%;\r\n        height: 10%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        .title-column {\r\n          position: relative;\r\n          width: 50%;\r\n          user-select: none;\r\n          &:first-child {\r\n            padding-left: 5px;\r\n          }\r\n          &:not(:first-child) {\r\n            padding-left: 20px;\r\n          }\r\n        }\r\n      }\r\n      .columns {\r\n        position: relative;\r\n        width: 100%;\r\n        height: 90%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        .left-side, .right-side {\r\n          position: relative;\r\n          width: 50%;\r\n          height: 90%;\r\n          display: block;\r\n          overflow-y: auto;\r\n        }\r\n\r\n        .left-side {\r\n          position: relative;\r\n          padding-right: 10px;\r\n          border-right: 1px solid gray;\r\n          .user {\r\n            position: relative;\r\n            width: 100%;\r\n            height: 40px;\r\n            display: flex;\r\n            align-items: center;\r\n            border-radius: 18px;\r\n            background: rgba(57, 79, 103, 0.3);\r\n            cursor: pointer;\r\n            user-select: none;\r\n\r\n            &:not(:first-child) {\r\n              margin-top: 10px;\r\n            }\r\n\r\n            span {\r\n              padding-left: 20px;\r\n            }\r\n          }\r\n          .no-user {\r\n            width: 100%;\r\n            height: 40px;\r\n            margin-top: 15px;\r\n            align-items: center;\r\n            display: flex;\r\n            user-select: none;\r\n\r\n            span {\r\n              margin-left: 20px;\r\n            }\r\n          }\r\n        }\r\n        .right-side {\r\n          position: relative;\r\n          padding-left: 10px;\r\n\r\n          .user {\r\n            position: relative;\r\n            width: 100%;\r\n            height: 40px;\r\n            display: flex;\r\n            align-items: center;\r\n            padding-right: 5px;\r\n            border-radius: 18px;\r\n            background: rgba(57, 79, 103, 0.3);\r\n            justify-content: space-between;\r\n            cursor: pointer;\r\n            user-select: none;\r\n\r\n            &:not(:first-child) {\r\n              margin-top: 10px;\r\n            }\r\n\r\n            span {\r\n              padding-left: 20px;\r\n            }\r\n            .remove-sign {\r\n              position: relative;\r\n              width: 30px;\r\n              height: 30px;\r\n              display: flex;\r\n              align-items: center;\r\n              justify-content: center;\r\n              color: white;\r\n              background: rgba(69, 69, 97, 0.7);\r\n              border-radius: 50%;\r\n              user-select: none;\r\n              &:hover {\r\n                background: rgba(46, 46, 65, 0.7);\r\n              }\r\n\r\n              .sign-wrapper {\r\n                position: relative;\r\n                width: 100%;\r\n                height: 100%;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n              }\r\n            }\r\n          }\r\n          .no-user {\r\n            width: 100%;\r\n            height: 40px;\r\n            margin-top: 15px;\r\n            align-items: center;\r\n            display: flex;\r\n            user-select: none;\r\n\r\n            span {\r\n              padding-left: 20px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n  }\r\n  .footer {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    flex-direction: row;\r\n    // min-height: 0%;\r\n    width: 100%;\r\n    height: 10%;\r\n    font-size: 150%;\r\n    .button {\r\n      border-radius: 5px;\r\n    }\r\n\r\n    .share {\r\n      background: rgba(28, 73, 119, 0.8);\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding: 10px;\r\n      cursor: pointer;\r\n      user-select: none;\r\n    }\r\n    .copyLink {\r\n      margin-left: 3%;\r\n    }\r\n  }\r\n  .close {\r\n    cursor: pointer;\r\n    padding: 10px 20px 15px 20px;\r\n    &:hover {\r\n      background: transparentize(#FFF, 0.95);\r\n    }\r\n  }\r\n  .header a {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .hours-modal {\r\n    padding: 10px 0 0 10px;\r\n    color: white;\r\n    position: absolute;\r\n    top: 75%;\r\n    left: 38%;\r\n    background: #3a3f50;\r\n    width: 35%;\r\n    height: 21%;\r\n    z-index: 2;\r\n    -webkit-box-shadow: -4px 3px 14px 0px rgba(114, 114, 121, 0.54);\r\n    -moz-box-shadow:    -4px 3px 14px 0px rgba(114, 114, 121, 0.54);\r\n    box-shadow:         -4px 3px 14px 0px rgba(114, 114, 121, 0.54);\r\n\r\n    .btn-copy-link {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: 190px;\r\n      height: 45px;\r\n      margin-top: 5px;\r\n      outline: 0 !important;\r\n      background: #fff;\r\n      text-align: center;\r\n      border-radius: 5px;\r\n      font-size: 16px;\r\n      color: black;\r\n      user-select: none;\r\n      box-shadow: none !important;\r\n      cursor: pointer;\r\n    }\r\n\r\n    &-success, &-error {\r\n      margin: 20px 0 0 25px;\r\n    }\r\n    &-success {\r\n      color: white;\r\n    }\r\n    &-error {\r\n      color: brown;\r\n    }\r\n    .form-control {\r\n      padding: .6rem .8rem !important;\r\n      border: 2px solid #ced4da !important;\r\n      transition: none !important;\r\n    }\r\n    select.form-control{\r\n      height: auto !important;\r\n      padding: .6rem .8rem calc(.6rem + 1px) .8rem !important;\r\n    }\r\n\r\n    .select-hours {\r\n      width: 83%;\r\n      display: flex;\r\n      justify-content: space-between;\r\n    }\r\n    .custom-select {\r\n      height: 45px;\r\n      width: 30%;\r\n      padding: .6rem .8rem !important;\r\n      border: 2px solid #ced4da !important;\r\n      transition: none !important;\r\n      border-radius: 4px;\r\n      margin: 5px 0 10px 0;\r\n    }\r\n\r\n    .div-for-link {\r\n      width: 0;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      height: 0;\r\n    }\r\n    .input-for-link {\r\n      display: flex;\r\n      width: 300px;\r\n      height: 45px;\r\n      // margin-left: 10px;\r\n      border: 0;\r\n      box-shadow: none !important;\r\n      outline: none !important;\r\n      background: #ffffff;\r\n      text-align: center;\r\n      border-radius: 5px;\r\n      font-size: 15.5px;\r\n    }\r\n\r\n    .copyLinkToClipboard {\r\n      display: flex;\r\n      width: 11%;\r\n      height: 45px;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  background: #565b6b;\r\n  opacity: 0.7;\r\n}\r\n::-webkit-scrollbar-track {\r\n  border-radius: 10px;\r\n}\r\n\r\n\r\n::-webkit-input-placeholder { /* Chrome */\r\n  color: #000;\r\n}\r\n\r\n::-moz-placeholder { /* Firefox 19+ */\r\n  color: #000;\r\n  opacity: 1;\r\n}\r\n:-moz-placeholder { /* Firefox 4 - 18 */\r\n  color: #000;\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
